export default "__VITE_ASSET__CqiffNPR__"